// extracted by mini-css-extract-plugin
export default {"leadersInput":"InviteContent_leadersInput__9HSHy"};